export default async function(records)
{
	return `
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th>Empresa</th>
					<th>ID</th>
					<th>SKU</th>
					<th>Produto</th>
					<th>Código</th>
					<th>Nível</th>
					<th>Fator</th>
					<th>Cap. Terciária</th>
					<th>Fabricante</th>
					<th>GTIN</th>
					<th>Padrão</th>
					<th>Inativa</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record =>
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td>${await this.key('companies', record.company_id, 'nick')}</td>
					<td>${record.id}</td>
					<td>${record.sku != null && String(record.sku).trim() !== '' ? String(record.sku) : '—'}</td>
					<td>${await this.key('products', [record.company_id, record.product_id], 'name')}</td>
					<td>${record.code || ''}</td>
					<td>${record.level || ''}</td>
					<td>${record.factor ?? ''}</td>
					<td>${record.tertiary_capacity ?? ''}</td>
					<td>${(record.display_manufacturer_nick != null && String(record.display_manufacturer_nick).trim() !== '')
						? String(record.display_manufacturer_nick).trim()
						: (record.manufacturer_id != null && record.manufacturer_id !== ''
							? (await this.key('manufacturers', [record.company_id, record.manufacturer_id], 'nick')) || '—'
							: '—')}</td>
					<td>${record.gtin || ''}</td>
					<td>${record.is_default ? 'SIM' : 'NAO'}</td>
					<td>${record.is_disabled ? 'SIM' : 'NAO'}</td>
				</tr>`
			))).join('') +
			`
			</tbody>
		</table>
	`;
};
